export const setTabEnabled = (tab, group, enabled) => {
  const el = document.getElementById(`workspace-cm-target-${tab?.uuid}`);
  const overlayId = 'global-screen-overlay';
  const tabsContainer = document.getElementById('workspace-tabs-container');

  const existingOverlay = document.getElementById(overlayId);

  if (enabled) {
    if (existingOverlay) {
      existingOverlay.remove();
      console.log('Overlay entfernt');
    }

    if (tabsContainer) {
      tabsContainer.style.zIndex = '';
      tabsContainer.style.position = '';
      tabsContainer.style.pointerEvents = '';
    }
    if(!el) return;

    Object.assign(el.style, {
      pointerEvents: 'auto',
      opacity: '1',
      cursor: 'pointer',
    });

  } else {
    Object.assign(el.style, {
      borderTop: `2.5px solid ${group.color}`,
      pointerEvents: 'none',
      cursor: 'not-allowed',
      backdropFilter: 'blur(0.6px)',            
    });

    if (!existingOverlay) {
      const overlay = document.createElement('div');
      overlay.id = overlayId;
      Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(0.6px)',
        zIndex: '9998',
        pointerEvents: 'all',
        cursor: 'not-allowed',
      });
      document.body.appendChild(overlay);
      console.log('Overlay hinzugefügt');
    }

    if (tabsContainer) {
      tabsContainer.style.zIndex = '9999';
      tabsContainer.style.position = 'relative';
      tabsContainer.style.pointerEvents = 'auto';
    }
  }
};
